import { render } from "./TextSuggestFilter.vue?vue&type=template&id=bc9c816a"
import script from "./TextSuggestFilter.vue?vue&type=script&lang=js"
export * from "./TextSuggestFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__